import { useState } from 'react';

import { ComboBoxBase } from './ComboBoxBase';
import type { ComboBoxBaseProps } from './ComboBoxBase';
import type { ComboBoxOption } from './types/ComboBoxOption';

type DistributiveOmit<T, Key extends PropertyKey> = T extends unknown ? Omit<T, Key> : never;

type ControlledComboBoxBaseProp =
    | 'async'
    | 'open'
    | 'search'
    | 'onOpenChange'
    | 'onSearchChange'
    | 'isInitialLoading'
    | 'isSearchLoading'
    | 'isLoadingMoreOptions'
    | 'isSelectedOptionsLoading'
    | 'onTriggerPointerEnter'
    | 'onOptionsScrollEnd';

type SyncComboBoxBaseProps<Option extends ComboBoxOption> = DistributiveOmit<
    ComboBoxBaseProps<Option>,
    ControlledComboBoxBaseProp
>;

export const SyncComboBoxBase = <Option extends ComboBoxOption = ComboBoxOption>(
    props: SyncComboBoxBaseProps<Option>
) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');

    return (
        <ComboBoxBase<Option>
            {...props}
            async={false}
            open={open}
            search={search}
            onOpenChange={setOpen}
            onSearchChange={setSearch}
        />
    );
};
